(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/announcement/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/widgets/announcement/assets/javascripts/init.js');

'use strict';

svs = svs || {};
svs.widget = svs.widget || {};
const widget = svs.widget.announcement = svs.widget.announcement || {};

if (typeof widget.init !== 'function') {
  widget.init = function() {
  };
}

function getCoreData() {
  svs.core = svs.core || {};
  svs.core.trinidadAnnouncements = svs.core.trinidadAnnouncements || {};

  const base = svs.core.trinidadAnnouncements.data || {};
  const trinidadAnnouncementConfig = {
    disableOnSSR: true,
    showPolicy: 'always'
  };

  svs.core.trinidadAnnouncements.data = Object.assign({}, base, trinidadAnnouncementConfig);
  return svs.core.trinidadAnnouncements.data;
}

getCoreData();

function onUpdate(e) {
  const detail = (e && e.detail) || {};
  const anns = Array.isArray(detail.announcements) ? detail.announcements : [];
  widget.init({ announcements: anns });
}

if (!widget._regInstalled && typeof document !== 'undefined' && document.addEventListener) {
  try {
    document.addEventListener('trinidad:announcement-update', onUpdate);
  } catch (_) {}
  widget._regInstalled = true;
}


 })(window);